<template>
  <div class="mobileLayout">
    <div class="item">
      <div class="header">
        <div class="itemTitle">选择产品</div>
        <i class="el-icon-close" @click="closeSelectProduct" />
      </div>
      <el-input
        class="search"
        v-model="productName"
        clearable
        placeholder="搜索产品名"
        style="width: 100%"
        suffix-icon="el-icon-search"
      />
    </div>
    <el-button class="addProduct" @click="addProductEntry">
      <img src="../../assets/statics/add.png" class="icon" />
      添加新产品
    </el-button>
    <div class="productList">
      <div :key="item.id" v-for="item in productList" class="productItem">
        <div class="productName" @click="selectProduct(item)">
          {{ item.productName }}
        </div>
        <div>
          <img
            src="../../assets/statics/remove.png"
            @click="askDeleteProduct(item)"
          />
          <img
            src="../../assets/statics/edit.png"
            @click="modifyProduct(item)"
          />
        </div>
      </div>
    </div>
    <el-dialog
      title="提示"
      center
      :visible.sync="visible"
      v-if="deleteItem"
      :modal="false"
      width="300px"
      :before-close="handleClose"
    >
      <span
        style="text-align: center; width: 100%; display: block; color: #111d3a"
      >
        是否确认删除当前产品信息
      </span>
      <div class="buttonGroup">
        <img
          src="../../assets/statics/confirm.png"
          @click="deleteSavedProduct"
        />
        <img src="../../assets/statics/wait.png" @click="deleteItem = null" />
      </div>
    </el-dialog>
    <AddProduct
      v-if="showProductPage"
      :addProduct="addProduct"
      :type="type"
      :editProduct="editProduct"
      :deleteProduct="deleteProductWhenEdit"
      :closeProductEntry="closeProductEntry"
    />
  </div>
</template>
<script>
import Api from "../../http/api";
import AddProduct from "./AddProduct.vue";

export default {
  components: { AddProduct },
  data() {
    return {
      productName: "",
      deleteItem: null,
      showProductPage: false,
      type: "ADD",
      editProduct: {},
    };
  },
  computed: {
    visible() {
      return Boolean(this.deleteItem);
    },
    userId() {
      return this.$store.state.user.id;
    },
    userName() {
      return this.$store.state.user.name;
    },
  },
  props: {
    productList: {
      type: Array,
      required: true,
      default: [],
    },
    getProductList: {
      type: Function,
      required: true,
      default: null,
    },
    selectProduct: {
      type: Function,
      required: true,
      default: null,
    },
    closeSelectProduct: {
      type: Function,
      required: true,
      default: null,
    },
  },
  methods: {
    handleClose() {
      this.deleteItem = null;
    },
    askDeleteProduct(item) {
      this.deleteItem = item;
    },
    modifyProduct(item) {
      this.type = "EDIT";
      console.log(item);
      this.editProduct = item;
      this.showProductPage = true;
    },
    getProducts() {
      this.getProductList();
    },
    addProductEntry() {
      this.type = "ADD";
      this.editProduct = {};
      this.showProductPage = true;
    },
    closeProductEntry() {
      this.showProductPage = false;
    },
    async addProduct(params, editId) {
      if (!this.userName) {
        return this.$message.error("未登录");
      }

      let res = await Api.Product.saveProduct({
        id: editId,
        type: "xiaohongshu-article",
        params,
      });
      if (res.error) {
        return this.$message.error(res.error.message);
      }
      this.$message.success("保存成功！");

      this.getProducts();
      this.showProductPage = false;
    },
    deleteProductWhenEdit(item) {
      this.deleteItem = item;
      this.deleteSavedProduct();
    },
    async deleteSavedProduct() {
      console.log(this.deleteItem);
      let res = await Api.Product.deleteProduct(id);

      if (res.error) {
        this.showProductPage = false;
        return this.$message.error("产品信息删除失败");
      }

      this.getProductList();
      this.$message.success("产品信息删除成功");
      this.deleteItem = null;
      this.showProductPage = false;
    },
  },
  created() {
    this.getProductList();
  },
};
</script>
<style lang="less" scoped>
.mobileLayout {
  padding: 16px 20px;
  z-index: 1000;
  background: #fff;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;

  .item {
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .itemTitle {
      color: #111d3a;
      font-weight: bold;
    }

    .search {
      margin-top: 12px;
      /deep/ .el-input__inner {
        border-radius: 26px;
        background-color: rgba(167, 167, 167, 0.13);
      }
    }
  }
  .addProduct {
    /deep/ span {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    width: 100%;
    margin-top: 24px;
    border-radius: 4px;
    box-shadow: 0 2px 10px 0px rgba(0, 0, 0, 0.12);

    .icon {
      margin-right: 4px;
    }
  }

  .productList {
    margin-top: 12px;

    .productItem {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: solid 1px #dadada;
      border-radius: 6px;
      padding: 0px 16px;

      .productName {
        flex: 1;
        padding: 10px;
      }

      img + img {
        margin-left: 24px;
      }
    }
  }

  .buttonGroup {
    display: flex;
    margin-top: 24px;
    justify-content: center;
    align-items: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/mobileChat/SelectProduct.vue